import i18n from "../i18n";

const createTagCategories = (tagCategories, tags) => {
  const obj = {};
  tagCategories.forEach((tc) => {
    Object.assign(obj, { [tc]: tags.filter((el) => el.category == tc) });
  });
  return obj;
};

const createEmployeesSearch = (
  e,
  optionalHeaders = ["collar", "location", "manager"]
) => {
  const search = [
    e.id,
    `${e.firstName} ${e.lastName}`,
    e.role,
    `${i18n.t("role." + e.role)}`,
    e.employeeId,
    ...e.modes.map((m) => m.name),
  ];

  const filteredTags = e.tags.filter(
    (t) =>
      !["location", "collar"].includes(t.category) ||
      optionalHeaders.includes(t.category)
  );

  if (filteredTags && filteredTags.length) {
    search.push(
      ...filteredTags.map((t) => t.name),
      ...filteredTags.map((t) => t.description)
    );
  }

  if (e.manager && optionalHeaders.includes("manager")) {
    search.push(`${e.manager.firstName} ${e.manager.lastName}`);
  }

  return search.join("|").toLowerCase();
};

const getMissingParentTags = (e) => {
  const tagsWithParents =
    e.tags && e.tags.length && e.tags.filter((t) => t.parent);

  if (tagsWithParents && tagsWithParents.length) {
    const tagsWoParent = tagsWithParents.filter(
      (twp) => !e.tags.some((t) => t.id == twp.parent.id)
    );

    return tagsWoParent;
  }
  return [];
};

export { createTagCategories, createEmployeesSearch, getMissingParentTags };
